export default __webpack_public_path__ + "static/media/energy.d56af1cd.jpg";